/* Maison Neema — option « Ajustement de closure sur ma perruque » (assets/neema-ajustement.js)
   1. Sur la fiche : si la case est cochée, l'envoi du formulaire est intercepté et les deux lignes
      (la pièce et le service) sont ajoutées d'un coup, liées par une propriété cachée _neema_bundle.
   2. Dans le panier : après tout changement de quantité ou retrait, le service suit la pièce —
      même quantité, et il disparaît si la pièce disparaît.
   Aucun fichier du développeur n'est modifié : le thème garde ses propres gestionnaires ; ce script
   agit avant eux (phase de capture) seulement quand la case est cochée.                                  */
(() => {
  if (window.NeemaAjustement) return;
  window.NeemaAjustement = true;

  const KEY = '_neema_bundle';      // lie la pièce et le service (propriété cachée : commence par _)
  const FLAG = '_neema_service';    // marque la ligne du service
  const R = window.routes || {};
  const ADD = R.cart_add_url || '/cart/add';
  const CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  const CART_URL = R.cart_url || '/cart';
  const nativeFetch = window.fetch.bind(window);

  /* ---------- 1. La fiche produit ---------- */
  function setup(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const check = box.querySelector('[data-neema-ajustement-check]');
    const fields = box.querySelector('.neema-ajustement__fields');
    const errorEl = box.querySelector('.neema-ajustement__error');
    check.addEventListener('change', () => { fields.hidden = !check.checked; });

    const pf = document.querySelector(`product-form[data-section-id="${box.dataset.sectionId}"]`)
      || box.closest('.product, .product__info, section')?.querySelector('product-form')
      || document.querySelector('product-form');
    if (!pf) return;
    const form = pf.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      if (!check.checked) return;                 // case décochée : le thème fait son travail normal
      event.preventDefault();
      event.stopImmediatePropagation();           // empêche le gestionnaire du thème (phase de bouillonnement)
      addBoth(pf, form, box, errorEl);
    }, true);                                      // phase de capture : passe avant le gestionnaire du thème
  }

  async function addBoth(pf, form, box, errorEl) {
    const submit = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
    const key = 'nb' + Date.now().toString(36);

    const laceProps = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) laceProps[m[1]] = v;
    }
    laceProps[KEY] = key;

    const serviceProps = {};
    serviceProps[KEY] = key;
    serviceProps[FLAG] = '1';
    serviceProps[document.documentElement.lang === 'en' ? 'For' : 'Pour'] = box.dataset.productTitle || '';
    box.querySelectorAll('[data-neema-prop]').forEach((el) => {
      if (el.value && el.value.trim()) serviceProps[el.dataset.neemaProp] = el.value.trim();
    });

    const cart = pf.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.section) : [];

    const body = {
      items: [
        { id, quantity: qty, properties: laceProps },
        { id: Number(box.dataset.serviceVariant), quantity: qty, properties: serviceProps },
      ],
      sections,
      sections_url: window.location.pathname,
    };

    if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.classList.add('loading'); }
    if (errorEl) errorEl.hidden = true;
    try {
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers['Content-Type'] = 'application/json';
      config.headers['Accept'] = 'application/javascript';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(body);
      const response = await nativeFetch(ADD, config).then((r) => r.json());
      if (response.status) {
        if (errorEl) { errorEl.textContent = response.description || box.dataset.errorText; errorEl.hidden = false; }
        else if (pf.handleErrorMessage) pf.handleErrorMessage(response.description);
        return;
      }
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: response });
      }
      if (cart && cart.renderContents) {
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        window.location = CART_URL;
      }
    } catch (e) {
      console.error('[Neema] ajout de la pièce et du service', e);
      if (errorEl) { errorEl.textContent = box.dataset.errorText; errorEl.hidden = false; }
    } finally {
      if (submit) { submit.removeAttribute('aria-disabled'); submit.classList.remove('loading'); }
      const spinner = pf.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  /* ---------- 2. Le panier : le service suit la pièce ---------- */
  let reconciling = false;
  async function reconcile(depth = 0) {
    if (reconciling || depth > 4) return;
    reconciling = true;
    try {
      const cartData = await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const laces = {}, services = {};
      cartData.items.forEach((item, i) => {
        const props = item.properties || {};
        const key = props[KEY];
        if (!key) return;
        if (props[FLAG]) services[key] = { item, line: i + 1 };
        else laces[key] = { item, line: i + 1 };
      });
      for (const key of Object.keys(services)) {
        const s = services[key];
        const target = laces[key] ? laces[key].item.quantity : 0;
        if (s.item.quantity === target) continue;
        const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-items');
        const sections = cartEl && cartEl.getSectionsToRender ? cartEl.getSectionsToRender() : [];
        const body = { line: s.line, quantity: target, sections: sections.map((x) => x.section), sections_url: window.location.pathname };
        const state = await nativeFetch(CHANGE, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        }).then((r) => r.json());
        if (!state.errors) render(state, sections);
        reconciling = false;
        return reconcile(depth + 1);          // les numéros de ligne ont pu changer : on repasse
      }
    } catch (e) {
      console.error('[Neema] synchronisation du service', e);
    } finally {
      reconciling = false;
    }
  }

  function render(state, sections) {
    if (!state.sections) return;
    sections.forEach((section) => {
      const html = state.sections[section.section];
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      const target = document.querySelector(section.selector) || document.querySelector(section.id);
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    });
    if (typeof updateCartCounters === 'function') updateCartCounters();
    if (typeof updateFreeShipping === 'function') updateFreeShipping();
    if (typeof handleCartInputNames === 'function') handleCartInputNames();
  }

  // Après chaque changement de panier fait par le thème (quantité, retrait), on vérifie les paires.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch(input, init);
    if (/\/cart\/(change|update)/.test(url)) {
      p.then((r) => r.clone().json()).then((data) => {
        if (data && Array.isArray(data.items)) setTimeout(() => reconcile(0), 80);
      }).catch(() => {});
    }
    return p;
  };

  function init() { document.querySelectorAll('[data-neema-ajustement]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
